import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Routes } from '../configs/api.router.config';
import { JData } from '../interfaces/j-data.interface';
import { LoginUserDetails } from '../models/login-module';
import { TEMP_CACHE } from './temp-cache.service';
import { UserGlobalService } from './user-global.service';

@Injectable()
export class HashTagService {
  // private readonly user = null;
  private readonly token = localStorage.getItem('poiuytrewq');
  private domains = 'APP_DOMAINS';

  constructor(
    private readonly httpClient: HttpClient,
    private readonly userGlobalService: UserGlobalService
  ) {}

  public getHashTags(jData: JData) {
    const params = new HttpParams().append('jData', JSON.stringify(jData));
   // console.log("params",params);
    return this.httpClient.get(Routes.getHashTagList, {
      params,
    });
  }

  public deleteHashTag(id: string | number) {
    return this.httpClient.delete(Routes.DeleteHashTag({ id }), {});
  }

  public updateHashTag(id: any, data: any) {
    return this.httpClient.post(Routes.updateHashTag({ id }), data, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      },
    });
  }
}

export const reload = new Subject();
export const reloadName = new Subject();
